import type { InputProps } from './input.types'

import { createContext } from '../utils'

const [InputProvider, useInputContext] = createContext<Partial<InputProps>>({ isOptional: true })

export { InputProvider, useInputContext }
